import type { FormDataOf } from '../../../../../types/templates';
import { ESPNHeroConfig } from '../../../../../types/banner/clients/DISNEY/creativity-configs';
import { disneyEspnHero } from '..';
import { getLeagueBackgrounds } from '../urls';

type FormData = FormDataOf<typeof disneyEspnHero>;

export const cleanFormData = (formData: FormData): ESPNHeroConfig => {
  const { league, teams, players } = formData;

  const slot1 = teams?.slot1 ?? '';
  const slot2 = teams?.slot2 ?? '';

  const mapped = (players ?? []).map(p => ({
    groupId: p.groupId,
    itemValue: p.itemValue,
    subImage: p.subImage,
    ...(p.isCustom && { isCustom: true })
  }));

  const sorted = [...mapped.filter(p => p.groupId === slot1), ...mapped.filter(p => p.groupId === slot2)];

  return {
    league,
    teams: { slot1, slot2 },
    players: sorted,
    backgrounds: Object.values(getLeagueBackgrounds(league))
  };
};
